import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * Request OTP code via Telegram
 * @param {string} telegramId - Telegram user ID
 * @returns {Promise<Object>} Response with message
 */
export const requestOTP = async (telegramId) => {
  const response = await apiClient.post('/api/auth/telegram/request-otp', {
    telegram_id: parseInt(telegramId),
  });
  return response.data;
};

/**
 * Verify OTP code and get tokens
 * @param {string} telegramId - Telegram user ID
 * @param {string} otpCode - OTP code from Telegram
 * @returns {Promise<Object>} Tokens and user data
 */
export const verifyOTP = async (telegramId, otpCode) => {
  const response = await apiClient.post('/api/auth/telegram/verify-otp', {
    telegram_id: parseInt(telegramId),
    otp_code: otpCode,
  });
  return response.data;
};

/**
 * Refresh access token
 * @param {string} refreshToken - Refresh token
 * @returns {Promise<Object>} New tokens
 */
export const refreshToken = async (refreshToken) => {
  const response = await apiClient.post('/api/auth/refresh', {
    refresh_token: refreshToken,
  });
  return response.data;
};

/**
 * Logout user
 * @param {string} accessToken - Access token
 * @returns {Promise<Object>} Logout response
 */
export const logout = async (accessToken) => {
  const response = await apiClient.post(
    '/api/auth/logout',
    {},
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );
  return response.data;
};

/**
 * Get current user data
 * @param {string} accessToken - Access token
 * @returns {Promise<Object>} User data
 */
export const getCurrentUser = async (accessToken) => {
  const response = await apiClient.get('/api/users/me', {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return response.data;
};

/**
 * Update user profile
 * @param {string} accessToken - Access token
 * @param {Object} userData - User data to update
 * @returns {Promise<Object>} Updated user data
 */
export const updateUserProfile = async (accessToken, userData) => {
  const response = await apiClient.put('/api/users/me', userData, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return response.data;
};

/**
 * Get user statistics
 * @param {string} accessToken - Access token
 * @returns {Promise<Object>} User statistics
 */
export const getUserStatistics = async (accessToken) => {
  const response = await apiClient.get('/api/users/me/statistics', {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return response.data;
};
